import { render, staticRenderFns } from "./CallButton.vue?vue&type=template&id=e5c2e36a&scoped=true"
import script from "./CallButton.vue?vue&type=script&lang=js"
export * from "./CallButton.vue?vue&type=script&lang=js"
import style0 from "./CallButton.vue?vue&type=style&index=0&id=e5c2e36a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5c2e36a",
  null
  
)

export default component.exports